import styled from 'styled-components'
import { IMaskInput } from 'react-imask'
import { Theme } from 'styles/Themes'

interface IStyleProps {
  small?: boolean
  green?: boolean
  secondary?: boolean
  disabled?: boolean
  medium?: boolean
  semi?: boolean
  erro?: any
  analyze?: boolean
  clickable?: boolean
  maxWidth?: number
}

interface IInfoCard {
  secondary?: boolean
  tertiary?: boolean
  filter?: string
  width?: number
}

export const ResMaskedInput = styled(IMaskInput)`
  border: none;
  width: 100%;
  background: ${(props: IStyleProps) => {
    if (props.green) return `${Theme.pallete.QUINARY}`
    if (props.secondary) return `${Theme.pallete.TERTIARY}`
    return `${Theme.pallete.SECONDARY}`
  }};
  cursor: ${(props: IStyleProps) => {
    if (props.disabled) return ''
    return 'pointer'
  }};
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  white-space: nowrap;
  line-height: normal;
  white-space: nowrap;
  font-family: ${Theme.fontFamily.SECONDARY};
  font-weight: 700;
  letter-spacing: 0.22px;
  font-size: 16px !important;
  ::placeholder {
    width: 100%;
    line-height: normal;
    white-space: nowrap;
    font-family: ${Theme.fontFamily.SECONDARY};
    font-weight: 700;
    letter-spacing: 0.22px;
    font-size: 16px;
    color: ${(props: IStyleProps) => {
      if (props.disabled) return `${Theme.pallete.PRIMARY}`
      if (props.green) return '#FFFFFF'
      return `${Theme.pallete.PRIMARY}`
    }};
  }
  ${(props: IStyleProps) => props.green && 'color: #FFFFFF;'}
`

export const ResumeInputCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 114px;
  padding: 16px 24px 24px;
  min-width: ${(props: IStyleProps) => {
    if (props.small) return '165px'
    if (props.medium) return '208px'
    if (props.semi) return '230px'
    return '252px'
  }};
  width: fit-content;
  max-width: ${(props) => (props.maxWidth ? `${props.maxWidth}px` : 'none')};
  border-radius: 5px;
  border: ${(props: IStyleProps) => {
    if (props.analyze) return '1px solid #FDAB3D'
    if (props.erro) return '1px solid red'
    return 'none'
  }};
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.25);
  background: ${(props: IStyleProps) => {
    if (props.green) return `${Theme.pallete.QUINARY}`
    if (props.secondary) return `${Theme.pallete.TERTIARY}`
    return `${Theme.pallete.SECONDARY}`
  }};
  cursor: ${(props: IStyleProps) => {
    if (props.disabled) return ''
    if (props.clickable) return ''
    return 'pointer'
  }};
  .title {
    color: ${Theme.pallete.PRIMARY};
    ${(props: IStyleProps) => props.green && 'color: #FFFFFF;'}
    font-style: normal;
    font-weight: 700;
    text-align: left;
    line-height: ${(props: IStyleProps) => {
      if (props.small) return '16.41px'
      return '18.75px'
    }};
    font-family: ${Theme.fontFamily.SECONDARY};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
  }
  .iconClickable {
    filter: ${(props: IInfoCard) => {
      if (props.filter) return `${props.filter}`
      if (props.secondary)
        return `'brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(48deg) brightness(105%) contrast(102%)'`
      return ``
    }};
    filter: ${(props: IStyleProps) =>
      props.green &&
      'brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(48deg) brightness(105%) contrast(102%)'};
    max-width: 20px;
    height: 20px;
  }
  .hidden-span {
    visibility: hidden;
    white-space: nowrap;
    margin-left: 50px;
    font-size: 14px;
    height: 1px;
  }
  .editIcon {
    filter: ${(props: IStyleProps) => {
      if (props.disabled) return `${Theme.icons.PRIMARY}`
      if (props.secondary)
        return `brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(48deg) brightness(105%) contrast(102%);`
      if (props.green)
        return `brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(48deg) brightness(105%) contrast(102%);`
      return ''
    }};
    max-width: 16px;
    height: 16px;
    top: 16px;
    right: 24px;
    position: absolute;
  }
  input {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    flex-wrap: wrap;
    border: none;
    width: 100%;
    background: ${(props: IStyleProps) => {
      if (props.green) return `${Theme.pallete.QUINARY}`
      if (props.secondary) return `${Theme.pallete.TERTIARY}`
      return `${Theme.pallete.SECONDARY}`
    }};
    cursor: ${(props: IStyleProps) => {
      if (props.disabled) return ''
      return 'pointer'
    }};
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    text-align: left;
    line-height: 21.09px;
    vertical-align: text-bottom;
    font-style: normal;
    line-height: normal;
    white-space: nowrap;
    font-family: ${Theme.fontFamily.SECONDARY};
    font-weight: 700;
    margin-left: 8px;
    letter-spacing: 0.22px;
    font-size: 16px;
    color: rgb(28, 29, 34);
    ::placeholder {
      color: ${(props: IStyleProps) => {
        if (props.disabled) return `${Theme.pallete.SECONDARY}`
        return `${Theme.pallete.PRIMARY}`
      }};
    }
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    ${(props: IStyleProps) => props.green && 'color: #FFFFFF;'}
    outline: none;
  }
  .on-edit-input {
    ${(props: IStyleProps) => props.green && 'border: 1px solid #FFFFFF;'}
    border-radius: 5px;
    width: 100%;
    font-style: normal;
    line-height: normal;
    white-space: nowrap;
    font-family: ${Theme.fontFamily.SECONDARY};
    font-weight: 700;
    margin-left: 8px;
    letter-spacing: 0.22px;
    font-size: 15px;
  }
  .edit-ok {
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    background: none;
    border: none;
    filter: none;
    color: #e07a58;
  }
  p {
    width: 16px;
    max-width: 16px;
    height: 18px;
    max-height: 18px;
    color: ${Theme.pallete.TERTIARY};
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    text-align: left;
    line-height: 18px;
  }
  .loading-img-button {
    width: 18px;
    height: 18px;
    top: 16px;
    right: 24px;
    position: absolute;
    animation: load 2s infinite linear;
  }

  @media only screen and (min-width: 1441px) {
    height: 128px;
    min-width: ${(props: IStyleProps) => {
      if (props.small) return '184px'
      if (props.medium) return '233px'
      if (props.semi) return '258px'
      return '284px'
    }};
  }
`
interface IErrorMsgProps {
  errorMsg?: string
}
export const ErrorMsg = styled.div<IErrorMsgProps>`
  color: #d61212;
  position: absolute;
  bottom: -6px;
  left: 0;
  font-size: 12px;
  transform: translateY(100%);
`
